export default __webpack_public_path__ + "static/media/Ivy-county-master-plan.5ddf883f.pdf";